import styled from 'styled-components';
export const BackButtonContainer = styled.div `
    display: flex;
    align-items: center;
    height: 31px;
    margin-top: 12px;
    // Setting pointer-events to auto so it works over embedded ad UI
    pointer-events: auto;
`;
BackButtonContainer.displayName = 'BackButtonContainer';
//# sourceMappingURL=index.js.map